import type { Step } from '@/types'

/** Objective-specific steps: Immunity (imunidade) */
export const immunitySteps: Step[] = []
